export const fallbackData = {
  company: {
    logo_url: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=200',
    phone_office: '068 680 1986',
    phone_technical: '083 450 1184',
    phone_sales: '068 680 1986',
    email_residential: 'jurie.sales@greenlightcity.co.za',
    email_commercial: 'kobus.sales@greenlightcity.co.za',
    email_technical: 'technical@greenlightcity.co.za',
    email_admin: 'admin@greenlightcity.co.za',
    address: 'South Africa',
    social_facebook: 'https://www.facebook.com/greenlightcityGLC',
    social_instagram: 'https://www.instagram.com/green_light_city/',
    social_linkedin: 'https://www.linkedin.com/company/green-light-city-sa/about/',
    suppliers: [
      { id: 1, name: 'Fox ESS', acronym: 'FE', logo_url: '' },
      { id: 2, name: 'Sunsynk', acronym: 'SS', logo_url: '' },
      { id: 3, name: 'JA Solar', acronym: 'JA', logo_url: '' },
      { id: 4, name: 'Freedom Won', acronym: 'FW', logo_url: '' },
      { id: 5, name: 'MSPD Africa', acronym: 'MP', logo_url: '' },
      { id: 6, name: 'Greenrich', acronym: 'GR', logo_url: '' },
      { id: 7, name: 'Revov', acronym: 'RV', logo_url: '' },
    ],
  },
  services: [
    {
      id: 1,
      category: 'energy_storage',
      title: 'Energy Storage & PV Systems',
      description: 'Every site has unique load profiles; we tailor hybrid and grid-tied systems for maximum savings, integration with your property, and future scalability.',
      features: [
        'Hybrid, off-grid, and grid-tied configurations',
        'Lithium storage sized for your usage',
        'Monitoring and performance alerts',
        'Tier-1 panels and inverters only'
      ],
      process_steps: [
        { step: 1, title: 'Site Assessment', description: 'Load profile, roof, and DB inspection.' },
        { step: 2, title: 'System Design', description: 'Right-size storage, PV, and protections.' },
        { step: 3, title: 'Installation', description: 'Certified install with compliance sign-off.' },
        { step: 4, title: 'Handover', description: 'Monitoring setup, training, and warranty pack.' }
      ]
    },
    {
      id: 2,
      category: 'electrical',
      title: 'Electrical Construction',
      description: 'Registered electricians for residential and commercial projects, repairs, and COCs.'
    },
    {
      id: 3,
      category: 'maintenance',
      title: 'Solar Maintenance & Cleaning',
      description: 'Bi-annual inspections and cleaning to protect output and warranties.'
    }
  ],
  testimonials: [
    {
      id: 1,
      name: 'Tanya M.',
      location: 'Cape Town',
      date: 'Jan 2026',
      rating: 5,
      content: 'Installation was tidy, on time, and they walked me through the app setup.'
    },
    {
      id: 2,
      name: 'Lunga P.',
      location: 'Johannesburg',
      date: 'Dec 2025',
      rating: 5,
      content: 'Load shedding is finally a non-event. Great support after install.'
    },
    {
      id: 3,
      name: 'Riaz E.',
      location: 'Pretoria',
      date: 'Oct 2025',
      rating: 5,
      content: 'Crew arrived early, neat cabling, COC issued same day.'
    },
    {
      id: 4,
      name: 'Lauren S.',
      location: 'Somerset West',
      date: 'Aug 2025',
      rating: 4,
      content: 'They resized our battery bank and resolved nuisance tripping.'
    }
  ],
  team: [
    { id: 1, name: 'Dominique Schwartz', role: 'Director', image_url: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=600' },
    { id: 2, name: 'Pieter Schwartz', role: 'General Manager', image_url: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=602' },
    { id: 3, name: 'Kobus van Niekerk', role: 'Sales – Commercial & Agricultural', image_url: 'https://images.unsplash.com/photo-1552374196-1ab2a1c593e8?w=600' },
    { id: 4, name: 'Jonathan Kleynhans', role: 'Technical Manager', image_url: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=600' },
    { id: 5, name: 'Jurie Boshoff', role: 'Sales – Residential', image_url: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=600' },
  ],
  projects: [
    { id: 1, title: '12 kW 3-Phase Sunsynk + 15 kWh Freedom Won', location: 'Durbanville', year: 2025, category: 'residential', description: 'Load-shedding ready hybrid system with rooftop mono array and lithium storage.', image_url: 'https://images.unsplash.com/photo-1509395176047-4a66953fd231?w=800' },
    { id: 2, title: '10.5 kW Fox ESS + EP11 Battery', location: 'Stellenbosch', year: 2025, category: 'residential', description: 'Quiet IP65 inverter with scalable EP11 high-voltage storage and full monitoring.', image_url: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=800' },
    { id: 3, title: '100 kW Atess Grid-Tied + 63 kWp Panels', location: 'Atess Plant, Gauteng', year: 2024, category: 'commercial', description: 'Industrial roof array with export limiting and performance dashboards.', image_url: 'https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=800' },
    { id: 4, title: 'Multiple 50 kW Sunsynk with Battery Banks', location: 'Logistics Park, KZN', year: 2024, category: 'commercial', description: 'Parallel inverters with large LFP banks for peak shaving and backup.', image_url: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=800' },
    { id: 5, title: 'Feature Garden Lighting & Pathways', location: 'Constantia', year: 2024, category: 'electrical', description: 'Low-voltage landscape lighting with smart controls and timers.', image_url: 'https://images.unsplash.com/photo-1582719478248-54e9f2af4b0c?w=800' },
    { id: 6, title: 'Residential Development Power Reticulation', location: 'Somerset West', year: 2023, category: 'electrical', description: 'Complete reticulation, metering, surge protection and compliance sign-off.', image_url: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=800' }
  ],
  products: [
    // Fox ESS
    {
      id: 1,
      name: 'Fox ESS 5 kW Hybrid Inverter',
      brand: 'foxess',
      price: 'Request quote',
      category: 'inverter',
      power_range: '3–6 kW single-phase (H1/AC1)',
      description: 'Single-phase hybrid inverter with IP65 enclosure, high-voltage battery support, remote monitoring, and 97%+ efficiency.',
      image_url: 'https://www.fox-ess.com/Public/Uploads/uploadfile/images/20251117/H1AC1.1.png',
      datasheet_url: 'https://www.fox-ess.com/Public/Uploads/uploadfile/files/20251219/ENH1G2DatasheetV2.020251219.pdf'
    },
    {
      id: 2,
      name: 'Fox ESS 8 kW Hybrid Inverter',
      brand: 'foxess',
      price: 'Request quote',
      category: 'inverter',
      power_range: '7–10.5 kW single-phase (KH/KA)',
      description: 'High-voltage hybrid inverter with plug-and-play install, IP65, and Fox ESS remote app/web monitoring.',
      image_url: 'https://www.fox-ess.com/Public/Uploads/uploadfile/images/20251117/KHKA.1.png',
      datasheet_url: 'https://www.fox-ess.com/Public/Uploads/uploadfile/files/20251219/ENH1G2DatasheetV2.020251219.pdf'
    },
    {
      id: 3,
      name: 'Fox ESS 10.5 kW Hybrid Inverter',
      brand: 'foxess',
      price: 'Request quote',
      category: 'inverter',
      power_range: '7–10.5 kW single-phase (KH/KA)',
      description: 'Single-phase hybrid inverter up to 10.5 kW with high voltage batteries, IP65 rating, fast EPS, and remote monitoring.',
      image_url: 'https://www.fox-ess.com/Public/Uploads/uploadfile/images/20251117/KHKA.1.png',
      datasheet_url: 'https://www.fox-ess.com/Public/Uploads/uploadfile/files/20251219/ENH1G2DatasheetV2.020251219.pdf'
    },
    {
      id: 4,
      name: 'Fox ESS 30 kW Hybrid Inverter',
      brand: 'foxess',
      price: 'Request quote',
      category: 'inverter',
      power_range: '15–30 kW three-phase (H3 Pro)',
      description: 'Three-phase hybrid inverter with 30 kW output, IP65, parallel support, fast EPS (<10 ms), and Wi‑Fi/4G monitoring.',
      image_url: 'https://mspd.africa/wp-content/uploads/2025/09/FoxESS-30kW-Front.webp',
      datasheet_url: 'https://www.fox-ess.com/products/hybrid-inverter/58'
    },
    {
      id: 'fox-ess-h3-plus-the-beast',
      name: 'Fox ESS H3 Plus – THE BEAST',
      brand: 'foxess',
      price: 'Request quote',
      category: 'inverter',
      power_range: 'Three-phase hybrid platform',
      description: 'High-power 3-phase hybrid inverter platform built for commercial-grade solar, battery integration and ultra-fast backup.',
      image_url: 'https://mspd.africa/wp-content/uploads/2025/10/100_125kW-AKA-The-Beast-Front-View-scaled-e1759927438861.webp',
      datasheet_url: 'https://www.fox-ess.com/Public/Uploads/uploadfile/files/20251204/ENH3PlusDatasheetV2.720251204-904.pdf'
    },
    {
      id: 5,
      name: 'Fox ESS 5 kWh IP65 Lithium Battery',
      brand: 'foxess',
      price: 'Request quote',
      category: 'battery',
      power_range: '5.18 kWh (EP5)',
      description: 'High-voltage LFP module, 90% DoD, ≥95% round‑trip efficiency, scalable to 20.8 kWh, IP65, floor/wall mount.',
      image_url: 'https://www.fox-ess.com/Public/Uploads/uploadfile/images/20251105/6911be068979d.svg',
      datasheet_url: 'https://www.fox-ess.com/products/battery/25'
    },
    {
      id: 6,
      name: 'Fox ESS 10 kWh IP65 Lithium Battery',
      brand: 'foxess',
      price: 'Request quote',
      category: 'battery',
      power_range: '10.24 kWh (EVO / EP11 class)',
      description: 'High-voltage LFP pack, 95% DoD, 6000+ cycles, IP65/66 outdoor-rated, scalable to 30 kWh with parallel modules.',
      image_url: 'https://www.fox-ess.com/Public/Uploads/uploadfile/images/20251206/StackableAIO.png',
      datasheet_url: 'https://www.green2go.co.uk/fox-ess-ep5-h-eco-high-voltage-5-18kwh-battery-with-warming-function-fox-ep5-h.html'
    },
    // Sunsynk
    {
      id: 7,
      name: 'Sunsynk 5 kW Hybrid Inverter',
      brand: 'sunsynk',
      price: 'Request quote',
      category: 'inverter',
      power_range: '5.5 kW single-phase (SUNSYNK-5K-SG03LP1)',
      description: 'Single-phase low-voltage hybrid inverter with 5 kW continuous output, dual MPPT, IP65 enclosure, and UPS/backup-ready operation for homes and small businesses.',
      image_url: 'https://static.wixstatic.com/media/50e58b_0cd44aca61c74d0e87821609a94bf914~mv2.png',
      datasheet_url: 'https://www.sunsynk.org/_files/ugd/7a0877_0019005feb734e388dabbfebb363607c.pdf'
    },
    {
      id: 8,
      name: 'Sunsynk 8 kW Hybrid Inverter',
      brand: 'sunsynk',
      price: 'Request quote',
      category: 'inverter',
      power_range: '8.8 kW single-phase (SUNSYNK-8K-SG01LP1)',
      description: 'High-capacity single-phase hybrid inverter with dual MPPT, fast transfer (≤10 ms), programmable export, and scalable operation for larger homes and business loads.',
      image_url: 'https://static.wixstatic.com/media/52fa1b_28ba0c8ae45447bfba69ec431993bee2~mv2.png',
      datasheet_url: 'https://www.sunsynk.org/_files/ugd/52fa1b_bdeb4eccaafc4fb188369c6603e3f3e9.pdf'
    },
    {
      id: 9,
      name: 'Sunsynk 10 kW Hybrid Inverter',
      brand: 'sunsynk',
      price: 'Request quote',
      category: 'inverter',
      power_range: '10 kW single-phase (SUNSYNK-10K-SG02LP1)',
      description: 'Single-phase hybrid inverter platform combining inverter, solar charger, and battery charger with configurable AC/solar charging and uninterrupted power support.',
      image_url: 'https://static.wixstatic.com/media/52fa1b_8c76bc218088456f86253b7a89a369f5~mv2.png',
      datasheet_url: 'https://www.sunsynk.org/_files/ugd/52fa1b_fdb046a45c1748e49ff37ad1b5d22180.pdf'
    },
    {
      id: 10,
      name: 'Sunsynk 12 kW Hybrid Inverter',
      brand: 'sunsynk',
      price: 'Request quote',
      category: 'inverter',
      power_range: '12 kW single-phase (SUNSYNK-12K-SG02LP1)',
      description: 'Single-phase 12 kW hybrid inverter for high-demand residential and commercial use, with integrated inverter + charger architecture and scalable solar-storage operation.',
      image_url: 'https://static.wixstatic.com/media/52fa1b_8c76bc218088456f86253b7a89a369f5~mv2.png',
      datasheet_url: 'https://www.sunsynk.org/_files/ugd/52fa1b_fdb046a45c1748e49ff37ad1b5d22180.pdf'
    },
    {
      id: 11,
      name: 'Sunsynk 16 kW Hybrid Inverter',
      brand: 'sunsynk',
      price: 'Request quote',
      category: 'inverter',
      power_range: '16 kW low-voltage hybrid (SYNK-16K-SG01LP1)',
      description: 'Sunsynk MAX 16 kW hybrid inverter with up to 300 A battery charge current, advanced multi-source power management, and high-output low-voltage performance.',
      image_url: 'https://static.wixstatic.com/media/39fbfb_4076d5957d4d47ed8f37c06b2b5ef088~mv2.png',
      datasheet_url: 'https://www.sunsynk.org/_files/ugd/52fa1b_b8124050ef774e7fb959b3e6698c9082.pdf'
    },
    {
      id: 12,
      name: 'Sunsynk 50 kW Hybrid Inverter',
      brand: 'sunsynk',
      price: 'Request quote',
      category: 'inverter',
      power_range: '30/50 kW three-phase HV (SUNSYNK-50K-SG01HP3-EU-BM4)',
      description: 'Three-phase high-voltage hybrid inverter range for commercial installations, combining inverter, solar charger, and battery charger with strong grid/generator integration.',
      image_url: 'https://static.wixstatic.com/media/52fa1b_0ad3c0d067e74d6496f97d2f5bb9a309~mv2.png',
      datasheet_url: 'https://www.sunsynk.org/_files/ugd/52fa1b_35d22bf576a9413ebe00aa7e0efb62c0.pdf'
    },
    {
      id: 13,
      name: 'Sunsynk Low-Voltage Lithium Battery',
      brand: 'sunsynk',
      price: 'Request quote',
      category: 'battery',
      power_range: '5.32 kWh LiFePO4 (SUN-BATT-5.32 / SUN-BATT-5.32R)',
      description: 'Sunsynk 5.32 kWh LiFePO4 storage battery with integrated BMS, straightforward parallel setup, and scalable architecture for larger backup and self-consumption systems.',
      image_url: 'https://static.wixstatic.com/media/52fa1b_53a4506517ea4b56bc2820aecfe960a9~mv2.png',
      datasheet_url: 'https://www.sunsynk.org/_files/ugd/52fa1b_6796fdbc8c1942caa8a65d9cba54df25.pdf'
    },
    // JA Solar
    {
      id: 14,
      name: 'JA Solar 11-BB PERC Half-Cell 455W Panel',
      brand: 'jasolar',
      price: 'Request quote',
      category: 'panel',
      power_range: '430-455W (JAM54D41 LB, DeepBlue 4.0)',
      description: 'n-type bifacial double-glass mono module with lower LID, strong low-irradiance response, improved temperature coefficient, and higher energy yield for better LCOE.',
      image_url: 'https://jasolar.africa/images/com_hikashop/upload/455w.jpg',
      datasheet_url: 'https://jasolar.africa/ja-solar-solutions/product/download/file_id-13'
    },
    {
      id: 15,
      name: 'JA Solar 11-BB PERC Half-Cell 540W Panel',
      brand: 'jasolar',
      price: 'Request quote',
      category: 'panel',
      power_range: 'DeepBlue 4.0 Series (high-power class)',
      description: 'High-output JA Solar module option aligned to the DeepBlue 4.0 family with half-cell and multi-busbar architecture for commercial and residential deployments.',
      image_url: 'https://jasolar.africa/images/com_hikashop/upload/jam72s41.jpg',
      datasheet_url: 'https://jasolar.africa/ja-solar-solutions/product/download/file_id-14'
    }
  ],
  faq: [
    { id: 1, category: 'general', question: 'How do I trust my installer?', answer: 'Choose companies registered with Department of Labour, PV Greencard, ECASA, and certified electricians/PV installers.' },
    { id: 2, category: 'technical', question: 'What inverter size do I need?', answer: 'Decide what must run during outages; then size inverter for peak load and battery for required runtime.' },
    { id: 3, category: 'technical', question: 'Single-phase vs 3-phase inverters?', answer: 'Single-phase can be used on 3-phase properties with DB changes; true 3-phase inverters keep phases balanced.' },
    { id: 4, category: 'technical', question: 'How many panels for a 5 kW inverter?', answer: 'Install at least 4 panels; 8–10 panels is typical to hit inverter sweet spot.' },
    { id: 5, category: 'technical', question: 'Battery runtime example?', answer: 'A 5 kWh battery running a 1 kW load lasts about 4 hours (depth-of-discharge and losses considered).' },
    { id: 6, category: 'legal', question: 'Must I register with the municipality/Eskom?', answer: 'Yes—SSEG applications, COCs, and approvals are required for grid-tied systems.' },
    { id: 7, category: 'legal', question: 'What documents are needed?', answer: 'ID/passport, recent electricity bill, application form, and proxy letter if in a company or trust.' },
    { id: 8, category: 'warranty', question: 'What are typical warranties?', answer: 'Inverters ~5–10 years, batteries ~10 years, panels 12–25 years, workmanship 1 year.' },
    { id: 9, category: 'technical', question: 'Low- vs high-voltage lithium batteries?', answer: 'Low-voltage (48V) are common for homes; high-voltage suit larger commercial arrays and higher efficiency strings.' },
    { id: 10, category: 'financial', question: 'What is the payback period?', answer: 'Depends on tariff and usage; most residential hybrid systems see 4–7 year ROI with daytime self-consumption and peak shaving.' },
    { id: 11, category: 'general', question: 'Do you install during power outages?', answer: 'Yes—using generators or scheduled windows; we still test and commission safely.' },
    { id: 12, category: 'maintenance', question: 'How often should systems be serviced?', answer: 'We recommend inspections in March–May and September–October with cleaning, thermal scans, MC4 checks, and firmware updates.' }
  ],
  blog: [
    { id: 1, slug: 'heineken-solar-plant-sa', title: "A Look at Heineken's Massive New Solar Plant in South Africa", category: 'Solar Power', excerpt: 'What large-scale brewing teaches us about PV design and uptime.', author: 'GLC Team', published_at: '2025-11-20', image_url: 'https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=801' },
    { id: 2, slug: 'sseg-at-municipalities', title: 'Application of Small Scale Embedded Generation at Municipalities and Eskom', category: 'Business', excerpt: 'Paperwork, metering, and approval steps for SSEG in South Africa.', author: 'Dominique Schwartz', published_at: '2025-10-05', image_url: 'https://images.unsplash.com/photo-1489515217757-5fd1be406fef?w=800' },
    { id: 3, slug: 'understanding-alternative-energy', title: 'Understanding Alternative Energy', category: 'Guides', excerpt: 'Hybrid vs off-grid vs grid-tied — which topology fits your load?', author: 'Karin Jacobs', published_at: '2025-09-12', image_url: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=800' },
    { id: 4, slug: 'why-businesses-are-going-solar', title: 'Why Businesses Are Going Solar', category: 'Solar Power', excerpt: 'Tariff hikes, reliability, and ESG—why firms invest in PV now.', author: 'Jurie Grobler', published_at: '2025-08-28', image_url: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=802' },
    { id: 5, slug: 'size-a-hybrid-system', title: 'How to Size a Hybrid System', category: 'Guides', excerpt: 'Match inverter, battery, and PV to your load profile.', author: 'GLC Team', published_at: '2025-07-02', image_url: 'https://images.unsplash.com/photo-1582719471137-2c8b9c1c1e1f?w=800' },
    { id: 6, slug: 'battery-cycle-life', title: 'Battery Cycle Life Explained', category: 'Energy', excerpt: 'LFP vs NMC, depth of discharge, and warranty fine print.', author: 'Karin Jacobs', published_at: '2025-06-03', image_url: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800' }
  ]
};
